/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutHeader from "../../inc/LayoutHeader";
import LayoutFooter from "../../inc/LayoutFooter";
import { Layout, Card, Table, Tag } from "antd";
import { getAPI } from "../../../utils/common";

import { VENDOR_OUTSTANDING_REPORT } from "../../../constants/api";

const { Content } = Layout;

function VendorOutstanding() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useLayoutEffect(() => {
    getAPI(
      VENDOR_OUTSTANDING_REPORT,
      (res) => {
        if (res.status) {
          const formatted = res.data.map((row, index) => ({
            key: index,
            ID: index + 1,
            Vendor: row.vendor_name,
            TotalOut: `₹ ${row.total_out}`,
            Adjustment: `₹ ${row.adjustment}`,
            Payments: `₹ ${row.payments}`,
            Outstanding: (
              <Tag color={row.outstanding > 0 ? "red" : "green"}>
                ₹ {row.outstanding}
              </Tag>
            ),
          }));
          setData(formatted);
        }
        setLoading(false);
      },
      () => setLoading(false),
      {}
    );
  }, []);

  const columns = [
    { title: "S.No", dataIndex: "ID", width: 70 },
    { title: "Vendor", dataIndex: "Vendor", width: 200 },
    { title: "Total Out", dataIndex: "TotalOut" },
    { title: "Adjustment", dataIndex: "Adjustment" },
    { title: "Payments", dataIndex: "Payments" },
    { title: "Outstanding", dataIndex: "Outstanding" },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card title="Vendor Outstanding Report">
          <Table
            loading={loading}
            columns={columns}
            dataSource={data}
            pagination={{ pageSize: 10 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default VendorOutstanding;
